import { render, staticRenderFns } from "./ReflectionFreeRedaction.vue?vue&type=template&id=78b5e1b0&scoped=true&"
import script from "./ReflectionFreeRedaction.vue?vue&type=script&lang=js&"
export * from "./ReflectionFreeRedaction.vue?vue&type=script&lang=js&"
import style0 from "./ReflectionFreeRedaction.vue?vue&type=style&index=0&id=78b5e1b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b5e1b0",
  null
  
)

export default component.exports